module.exports = __webpack_public_path__ + "static/media/ME.0400ec95.svg";